var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0845 16.4241C16.3187 16.6536 16.6946 16.6498 16.9241 16.4155C17.1536 16.1813 17.1498 15.8054 16.9155 15.5759L16.0845 16.4241ZM13.9903 12.71C13.7561 12.4805 13.3802 12.4843 13.1507 12.7186C12.9212 12.9528 12.9251 13.3287 13.1593 13.5582L13.9903 12.71ZM14.5729 9.33334C14.5729 11.9509 12.4509 14.0729 9.83333 14.0729V15.2604C13.1068 15.2604 15.7604 12.6068 15.7604 9.33334H14.5729ZM9.83333 14.0729C7.21573 14.0729 5.09375 11.9509 5.09375 9.33334H3.90625C3.90625 12.6068 6.5599 15.2604 9.83333 15.2604V14.0729ZM5.09375 9.33334C5.09375 6.71573 7.21573 4.59375 9.83333 4.59375V3.40625C6.5599 3.40625 3.90625 6.0599 3.90625 9.33334H5.09375ZM9.83333 4.59375C12.4509 4.59375 14.5729 6.71573 14.5729 9.33334H15.7604C15.7604 6.0599 13.1068 3.40625 9.83333 3.40625V4.59375ZM16.9155 15.5759L13.9903 12.71L13.1593 13.5582L16.0845 16.4241L16.9155 15.5759Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e1b1e664294dcd836549787af8db0de1.svg";
export { ForwardRef as ReactComponent };